import { render, staticRenderFns } from "./BargainRecord.vue?vue&type=template&id=faa76874"
import script from "./BargainRecord.vue?vue&type=script&lang=js"
export * from "./BargainRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports